import axios from "axios";
import { Button, DataGrid } from "devextreme-react";
import {
  Column,
  FilterRow,
  GroupPanel,
  Grouping,
  HeaderFilter,
  Item,
  LoadPanel,
  Lookup,
  Scrolling,
  SearchPanel,
  Selection,
  StateStoring,
  Toolbar,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import FileItem from "./FileItem";
import { CAT, CAT_FILTER, TYPE, TYPE_FILTER } from "./data";

export default function SOPGrid() {
  const selectedDoc = useSelector((state) => state.SOPViewer.selectedDoc);

  const [dataSource, setDataSource] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const gridRef = useRef(null);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "docNo",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/SOPViewer`
          );

          return result.data;
        },
      })
    );
  }, []);

  const onClickCollapseAll = () => {
    setExpanded(!expanded);
  };

  const onClickTop = () => {
    gridRef.current.instance.getScrollable().scrollTo(0);
  };

  const renderGridCell = (data) => {
    const { docNo, ver, type, docTitle } = data.data;

    return <FileItem docNo={docNo} ver={ver} type={type} docTitle={docTitle} />;
  };

  const onRowPrepared = (e) => {
    if (e.rowType == "data") {
      e.rowElement.style.height = "50px";
    }
  };

  return (
    <div className="list" style={{ width: "1000px", paddingLeft: "10px" }}>
      <DataGrid
        id="SOPGrid"
        ref={gridRef}
        dataSource={dataSource}
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        allowColumnResizing={true}
        onRowPrepared={onRowPrepared}
        height={"100%"}
        style={{
          maxHeight: "calc(100vh - 145px)",
        }}
      >
        <LoadPanel enabled={true} />

        <Grouping autoExpandAll={expanded} expandMode={"rowClick"} />
        <GroupPanel visible={true} />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} width={240} placeholder={"Search..."} />

        <Selection mode={"single"} />

        <Scrolling
          mode={"virtual"}
          preloadEnabled={true}
          showScrollbar="always"
        />

        <Toolbar>
          <Item location={"before"}>
            <Button
              style={{
                backgroundColor: "#f5f5f5",
              }}
              icon={expanded ? "chevronright" : "chevrondown"}
              onClick={onClickCollapseAll}
            />
          </Item>
          <Item name="groupPanel" />
          <Item location={"after"}>
            <Button
              style={{
                backgroundColor: "#f5f5f5",
              }}
              icon={"chevronup"}
              onClick={onClickTop}
            />
          </Item>
          <Item location={"after"} name="searchPanel" />
        </Toolbar>

        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={"SOPViewer.SOPGrid"}
        />

        <Column
          dataField="cat"
          caption="Category"
          dataType="string"
          groupIndex={0}
        >
          <Lookup dataSource={CAT} valueExpr="id" displayExpr={"name"} />
          <HeaderFilter dataSource={CAT_FILTER} />
        </Column>
        <Column
          dataField="docNo"
          caption="Document No."
          dataType="string"
          width={"140"}
        />
        <Column
          dataField="type"
          caption="Type"
          dataType="string"
          width={"100"}
          groupIndex={1}
        >
          <Lookup dataSource={TYPE} valueExpr="id" displayExpr={"name"} />\
          <HeaderFilter dataSource={TYPE_FILTER} />
        </Column>
        <Column
          dataField="ver"
          caption="Version"
          dataType="string"
          width={"100"}
          alignment={"center"}
        />
        <Column
          dataField="docTitle"
          caption="Document Title"
          dataType="string"
        />
        <Column
          dataField="date"
          caption="Date"
          dataType="date"
          format={"yyyy-MM-dd"}
          width={"105"}
          alignment={"center"}
        />
        <Column
          caption="File"
          // width={80}
          width={120}
          alignment={"center"}
          cellRender={renderGridCell}
        />
      </DataGrid>
    </div>
  );
}
